<template>
  <div style="text-align: center; height: 43px;">

    <img src="@/assets/images/logo/bottomleftban.png" alt="topBanner" style="width: 100%; bottom: 2%; height: 30px;" />
  </div>
</template>

<script>
export default {
  methods: {
    topBannerRef() {

    },
  },
};
</script>
